import React from 'react'

import {
  AlignItems,
  Body2,
  Box,
  Color,
  Display,
  FontWeight,
  Icon,
  IconVariant,
  Space,
  Text,
} from '@gousto-internal/citrus-react'
import { parseMessageContent } from '../utils/templateUtils'
import { BannerConfig } from '../types'

export interface CheckoutNDDBannerProps {
  config?: BannerConfig | null
}

export const CheckoutNDDBanner: React.FC<CheckoutNDDBannerProps> = ({ config }) => {
  const { message } = config || {}

  if (!config || !message) {
    return null
  }

  return (
    <Box display={Display.Flex} alignItems={AlignItems.Center}>
      <Icon name="tick" variant={IconVariant.Confirmation} />
      <Space size={[1, null, 3]} direction="horizontal" />
      <Body2 color={Color.ColdGrey_800} size={2}>
        {parseMessageContent(message, {
          span: (content, index) => (
            <Text
              key={index}
              color={Color.Success_800}
              fontWeight={FontWeight.SemiBold}
              display={Display.Inline}
              size={2}
            >
              {content}
            </Text>
          ),
        })}
      </Body2>
    </Box>
  )
}
